import { GLOBAL_ADMIN_PERMISSION, SUPER_ADMIN_PERMISSION, } from './AdminPermissions';
export const AdminPermissionGroups = {
    globalAdminPermissionGroup: {
        name: 'Global Admin Permission Group',
        codeName: 'globalAdminPermissionGroup',
        pagePermissions: [GLOBAL_ADMIN_PERMISSION],
        endpointPermissions: [GLOBAL_ADMIN_PERMISSION],
    },
    ordersPermissionGroup: {
        name: 'Orders Permission Group',
        codeName: 'ordersPermissionGroup',
        pagePermissions: [
            'ordersPagePermission',
            'orderGeneratePagePermission',
            'singleOrderPagePermission',
            'newOrderPagePermission',
            'orderStatisticsPagePermission',
            'printOrderPreparationPagePermission',
            'printOrderPreparationDayPagePermission',
            'printOrderReceiptPagePermission',
            'printAllSingleOrderPagePermission',
            'printAllOrdersReceiptForDatePagePermission',
            'printAllOrdersForDatePagePermission',
            'printAllOrdersForTodayPagePermission',
            'prototypeVikingOrderPagePermission',
            'exportPagePermission',
            'productCounterOverviewPagePermission',
            'orderControlPanelPagePermission',
            'orderMonitoringPagePermission',
            'orderControlPanelReactPagePermission',
        ],
        endpointPermissions: ['orders.*', 'statistics/*', 'admin-home-links/*'],
    },
    generalSettingsPermissionGroup: {
        name: 'General Settings Permission Group',
        codeName: 'generalSettingsPermissionGroup',
        pagePermissions: ['settingsPagePermission', 's3CloudPagePermission', 'userInvitationsReactPagePermission'],
        endpointPermissions: [],
    },
    tenantSettingsPermissionGroup: {
        name: 'Tenant Settings Permission Group',
        codeName: 'tenantSettingsPermissionGroup',
        pagePermissions: [
            'tenantSettingsPagePermission',
            'featureTogglePagePagePermission',
            'synchronizationsPagePermission',
            'globalVersionsReactPagePermission',
            'globalVersionsGboPagePermission',
        ],
        endpointPermissions: ['roles/*', 'global-versions/*', 'sse/*', 'admin-home-links/*'],
    },
    shopSettingsPermissionGroup: {
        name: 'Shop Settings Permission Group',
        codeName: 'shopSettingsPermissionGroup',
        pagePermissions: [
            'shopSettingsPagePermission',
            'shopOptionsPagePermission',
            'shopsSettingsPagePermission',
            'timePickerPagePermission',
            'shopInfoPagePermission',
        ],
        endpointPermissions: [],
    },
    productsPermissionGroup: {
        name: 'Products Permission Group',
        codeName: 'productsPermissionGroup',
        pagePermissions: [
            'productsPagePermission',
            'productOverviewPagePermission',
            'productCreatePagePermission',
            'ingredientsPagePermission',
            'ingredientsOverviewPagePermission',
            'productsIngredientsPagePermission',
            'productIngredientsOverviewPagePermission',
            'createProductIngredientsPagePermission',
            'createIngredientOverviewPagePermission',
            'productStatisticsPagePermission',
            'productMonitoringPagePermission',
            'productMonitoring2PagePermission',
            'productMonitoring3PagePermission',
            'productMonitoring4PagePermission',
            'productBadgesPagePermission',
        ],
        endpointPermissions: ['products/mass-editing-products.READ', 'products/mass-editing-products.WRITE'],
    },
    catalogPermissionGroup: {
        name: 'Catalog Permission Group',
        codeName: 'catalogPermissionGroup',
        pagePermissions: [
            'catalogPagesPagePermission',
            'catalogPagesUIPagePermission',
            'catalogPagesOverviewPagePermission',
            'catalogPagesUIOverviewPagePermission',
            'enrichedProductCatalogsPagePermission',
        ],
        endpointPermissions: [],
    },
    developerPermissionGroup: {
        name: 'Developer Permission Group',
        codeName: 'developerPermissionGroup',
        pagePermissions: [
            'operationsPagePermission',
            'demoDataPagePermission',
            'prototypePaymentsPagePermission',
            'devSupportPagePermission',
        ],
        endpointPermissions: [],
    },
    pickupRulesPermissionGroup: {
        name: 'Pickup Rules Permission Group',
        codeName: 'pickupRulesPermissionGroup',
        pagePermissions: [
            'pickupDateTimeRulesPagePermission',
            'pickupRulesSinglePagePermission',
            'pickupRulesReactPagePermission',
        ],
        endpointPermissions: [],
    },
    priceRulesPermissionGroup: {
        name: 'Price Rules Permission Group',
        codeName: 'priceRulesPermissionGroup',
        pagePermissions: ['priceRulesPagePermission', 'priceRulesReactPagePermission'],
        endpointPermissions: [],
    },
    marketingPermissionGroup: {
        name: 'Marketing Permission Group',
        codeName: 'marketingPermissionGroup',
        pagePermissions: [
            'marketingCardsPagePermission',
            'targetingGroupsPagePermission',
            'crossSellRulesPagePermission',
            'termsAndConditionsPagePermission',
            'upsellRulesReactPagePermission',
        ],
        endpointPermissions: ['upsale-rules/*', 'terms-and-conditions/*', 'admin-home-links/*'],
    },
    capacityRulesPermissionGroup: {
        name: 'Capacity Rules Permission Group',
        codeName: 'capacityRulesPermissionGroup',
        pagePermissions: [
            'capacityRulesPrototypePagePermission',
            'capacityRulesPagePermission',
            'capacityPrototypeReactPagePermission',
        ],
        endpointPermissions: [],
    },
    localizationPermissionGroup: {
        name: 'Localization Permission Group',
        codeName: 'localizationPermissionGroup',
        pagePermissions: ['localizationSettingsPagePermission'],
        endpointPermissions: [],
    },
    vouchersPermissionGroup: {
        name: 'Vouchers Permission Group',
        codeName: 'vouchersPermissionGroup',
        pagePermissions: ['vouchersPagePermission', 'voucherRulesReactPagePermission'],
        endpointPermissions: [],
    },
    invitationsPermissionGroup: {
        name: 'Invitations Permission Group',
        codeName: 'invitationsPermissionGroup',
        pagePermissions: ['userInvitationsReactPagePermission'],
        endpointPermissions: [],
    },
    punchCardsPermissionGroup: {
        name: 'Punch Cards Permission Group',
        codeName: 'punchCardsPermissionGroup',
        pagePermissions: ['punchCardRulesPagePermission'],
        endpointPermissions: [],
    },
    subscriptionsPermissionGroup: {
        name: 'Subscriptions Permission Group',
        codeName: 'subscriptionsPermissionGroup',
        pagePermissions: ['subscriptionsFraudProtectionPagePermission'],
        endpointPermissions: [],
    },
    shopManagementGroup: {
        name: 'Shop Management Permission Group',
        codeName: 'shopManagementGroup',
        pagePermissions: ['shopSettingsReactPagePermission', 'discountsPagePermission'],
        endpointPermissions: ['open-close-product/*', 'vouchers/*', 'intadm/dsfinvk/_generateAndDownloadDsFinVkFile.WRITE'],
    },
    areaManagementGroup: {
        name: 'Area Management Permission Group',
        codeName: 'areaManagementGroup',
        pagePermissions: [
            'shopSettingsReactPagePermission',
            'productAvailabilityReactPagePermission',
            'discountsPagePermission',
            'clientRedirectsPagePermission',
        ],
        endpointPermissions: [
            'open-close-product/*',
            'shop-change/*',
            'shop-settings/*',
            'admin-home-links/*',
            'vouchers/*',
            'products/*',
            'category/*',
            'client-redirects/*',
            'intadm/dsfinvk/_generateAndDownloadDsFinVkFile.WRITE',
        ],
    },
    tenantCreationGroup: {
        name: 'Tenant Creation Permission Group',
        codeName: 'tenantCreationGroup',
        pagePermissions: [SUPER_ADMIN_PERMISSION],
        endpointPermissions: ['tenants-adm/*'],
    },
    utilitiesGroup: {
        name: 'Utilities Group',
        codeName: 'utilitiesGroup',
        pagePermissions: [SUPER_ADMIN_PERMISSION],
        endpointPermissions: ['admin/util/*'],
    },
    wasteRootCompanyPermissionGroup: {
        name: 'Waste Root Company Permission Group',
        codeName: 'wasteRootCompanyPermissionGroup',
        pagePermissions: [
            'weighingRoadOverviewPagePermission',
            'weighingRoadCaseOverviewPagePermission',
            'invoicesPagePermission',
            'co2BuildingOverviewPagePermission',
            'co2CompanyTotalsPagePermission',
        ],
        endpointPermissions: [],
    },
    wasteB2BAdminPermissionGroup: {
        name: 'Waste B2B Admin Permission Group',
        codeName: 'wasteB2BAdminPermissionGroup',
        pagePermissions: [
            'weighingRoadOverviewPagePermission',
            'weighingRoadCaseOverviewPagePermission',
            'invoicesPagePermission',
            'co2BuildingOverviewPagePermission',
            'co2CompanyTotalsPagePermission',
            'informationPagePermission',
        ],
        endpointPermissions: [],
    },
    wasteB2BAdvisorPermissionGroup: {
        name: 'Waste B2B Advisor Permission Group',
        codeName: 'wasteB2BAdvisorPermissionGroup',
        pagePermissions: [
            'weighingRoadOverviewPagePermission',
            'weighingRoadCaseOverviewPagePermission',
            'invoicesPagePermission',
            'informationPagePermission',
        ],
        endpointPermissions: [],
    },
    wasteB2BDebtorPermissionGroup: {
        name: 'Waste B2B Debtor Permission Group',
        codeName: 'wasteB2BDebtorPermissionGroup',
        pagePermissions: [
            'weighingRoadOverviewPagePermission',
            'weighingRoadCaseOverviewPagePermission',
            'invoicesPagePermission',
            'informationPagePermission',
        ],
        endpointPermissions: [],
    },
    wasteB2BDriverPermissionGroup: {
        name: 'Waste B2B Driver Permission Group',
        codeName: 'wasteB2BDriverPermissionGroup',
        pagePermissions: [
            'weighingRoadOverviewPagePermission',
            'weighingRoadCaseOverviewPagePermission',
            'informationPagePermission',
        ],
        endpointPermissions: [],
    },
    customerAdministrationPermissionGroup: {
        name: 'Administrate customers',
        codeName: 'customerAdministrationPermissionGroup',
        pagePermissions: ['customerAdministrationPagePermission'],
        endpointPermissions: [],
    },
    customerUserAdministrationPermissionGroup: {
        name: 'Administrate customer users',
        codeName: 'customerUserAdministrationPermissionGroup',
        pagePermissions: ['customerUsersAdministrationPagePermission'],
        endpointPermissions: [],
    },
    customerUserPermissionGroup: {
        name: 'RGS Customer Users',
        codeName: 'customerUserPermissionGroup',
        pagePermissions: [
            'weighingRoadCaseOverviewPagePermission',
            'rgsCustomerUserPagePermission',
            'weighingRoadOverviewPagePermission',
            'invoicesPagePermission',
            'informationPagePermission',
        ],
        endpointPermissions: [],
    },
    customerServicePermissionGroup: {
        name: 'Customer Service Permission Group',
        codeName: 'customerServicePermissionGroup',
        pagePermissions: ['ordersCrmPagePermission', 'usersCrmPagePermission'],
        endpointPermissions: [
            'orders.READ',
            'orders.WRITE',
            'products.READ',
            'category.READ',
            'catalog.READ',
            'users.READ',
            'users/sendPoints.WRITE',
            'vouchers.WRITE',
            'app-users/logOutAllDevicesAdmin.READ',
            'vouchers/_paginated.READ',
            'vouchers/_channel.READ',
        ],
    },
};
